import { IonCard, IonIcon } from '@ionic/react'
import { pushOutline } from 'ionicons/icons'

import React, { useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../components/actions/Button'
import { ConsumptionDataContext } from '../../../contexts/ConsumptionDataContext'
import useUser from '../../../contexts/hooks/useUser'
import { ObjectContext } from '../../../contexts/objectContext/ObjectContext'
import { trpc } from '../../../modules/trpc'
import ModalWrapper from '../../../wrappers/modalWrapper/ModalWrapper'

const ContractComparison = () => {
	const { price } = useContext(ObjectContext)
	const { consumptionData } = useContext(ConsumptionDataContext)
	const { lastAvailableConsumptionData } = useContext(ConsumptionDataContext)
	const object = useContext(ObjectContext)

	const { user } = useUser()

	const { t } = useTranslation('pages_overview')

	const { data: vaeComparisonSpotContractAccumulation } =
		trpc.objects.getInvoiceAccumulation.useQuery(
			{
				objectId: object.id,
				from: lastAvailableConsumptionData?.startOf('month').format() ?? '',
				to: lastAvailableConsumptionData?.endOf('day').format() ?? '',
				isSpotMargin: true,
				price: 0.4,
				groupBy: 'month',
			},
			{ enabled: Boolean(lastAvailableConsumptionData) }
		)

	if (!user) return null

	const [monthlyBill, monthlySpotWithMargin, monthlyBillWithSpotMargin] = useMemo(() => {
		const lastMonthConsumption = consumptionData.comparisonMonth.kwh

		const monthlySpotWithMargin =
			vaeComparisonSpotContractAccumulation![0].avgPricePerConsumption ?? 0

		const monthlyBill = Math.round(lastMonthConsumption * price.value) / 100
		const monthlyBillWithSpotMargin = Math.round(lastMonthConsumption * monthlySpotWithMargin) / 100

		return [monthlyBill, monthlySpotWithMargin, monthlyBillWithSpotMargin]
	}, [consumptionData.comparisonMonth.kwh, price.value, vaeComparisonSpotContractAccumulation])

	return (
		<ModalWrapper>
			<div id='contract-comparison' className='text-text-dark dark:text-white'>
				<div className='contract-header'>
					<div className='title'>{t('contractComparison.alaOtsikko')} </div>
					<div className='bottom'>
						<div className='prediction'>
							<div className='value font-semibold tracking-wide text-highlight'>
								{monthlyBill} €
							</div>
							<div className='text-base text-text-grey-200 dark:text-text-grey-100'>
								{t('contractComparison.laskuarvio')}
							</div>
						</div>
						<div className='prediction left pl-4 border-l border-[#c3c3c3] dark:border-brand-secondary-200-dark'>
							<div className='value font-semibold tracking-wide text-highlight'>{price.value}</div>
							<div className='text-base text-text-grey-200 dark:text-text-grey-100'>snt / kwh</div>
						</div>
					</div>
					<div className='text text-text-grey-200 dark:text-text-grey-100'>
						{t('contractComparison.kiinteahinta')}
					</div>
				</div>

				<IonCard className='suggester bg-background-200-light dark:bg-surface-dark text-text-dark dark:text-white'>
					<div className='title text-lg'>{t('contractComparison.tuntihinta')}</div>
					<div className='bottom'>
						<div className='prediction'>
							<div className='value text-brand-primary-100-light'>
								{' '}
								{monthlyBillWithSpotMargin.toFixed(2)} €{' '}
							</div>
							<div className='text-base text-text-grey-200 dark:text-text-grey-100'>
								{t('contractComparison.laskuarvio')}
							</div>
						</div>
						<div className='prediction left pl-4 border-l border-[#c3c3c3] dark:border-brand-primary-200-dark'>
							<div className='value text-brand-primary-100-light'>
								{' '}
								{monthlySpotWithMargin.toFixed(2)}
							</div>
							<div className='text-base text-text-grey-200 dark:text-text-grey-100'>{`snt/kwh ${t('contractComparison.keskimaarin')}`}</div>
						</div>
					</div>
					<Button
						onClick={() => {
							window.open('https://vihreaenergia.fi/sahkosopimukset/verraton-kampanja/')
						}}
					>
						{t('contractComparison.vaihda')} <IonIcon className='ml-2' icon={pushOutline} />
					</Button>
					<div className='bottom-text'>
						<div className='important text-lg mb-1'> {t('contractComparison.tarkeaa')} </div>
						<div className='text text-text-grey-200 dark:text-text-grey-100'>
							{t('contractComparison.info')}
						</div>
					</div>
				</IonCard>
			</div>
		</ModalWrapper>
	)
}
export default ContractComparison
